<template>

</template>


<script setup>
import { onMounted } from 'vue'
import { useSystemStore } from '@/stores/system'
import { useAuthStore } from '@/stores/auth'
import { useRoute, useRouter } from 'vue-router'

const systemStore = useSystemStore()
const authStore = useAuthStore()
const route = useRoute()
const router = useRouter()

onMounted(() => {

  impersonateUser(route.params.id)

})

const impersonateUser = (id) => {

  authStore.xrequest(id).then(result => {
    if (result.success === true) {
      authStore.userAuthorized = true

      if (systemStore.userDetail.userType.trim() == 'Partner') {
          if (systemStore.requestedRoute.trim().length > 0) {
              router.push({ name: systemStore.requestedRoute })
          } else {
              router.push({ name: 'home-partner' })
          }
      } else if (systemStore.userDetail.userType.trim() == 'Distributor') {
          if (systemStore.requestedRoute.trim().length > 0) {
              router.push({ name: systemStore.requestedRoute })
          } else {
              router.push({ name: 'home-distributor' })
          }
      }
      else if (systemStore.userDetail.userType.trim() == 'Dell'
          || systemStore.userDetail.userType.trim() == 'TP'
          || systemStore.userDetail.userType.trim() == 'PAM'
          || systemStore.userDetail.userType.trim() == 'Dell Marketing'
          || systemStore.userDetail.userType.trim() == 'Dell'
          || systemStore.userDetail.userType.trim() == 'TIC_Admin') {
          if (systemStore.requestedRoute.trim().length > 0) {
              router.push({ name: systemStore.requestedRoute })
          } else {
              router.push({ name: 'home-partner' })
          }
      }
    }
  })
}

</script>

<style scoped>

</style>